import React from "react";
import "../../../css/pages/public_pages/company/Careers.css";

const Careers = () => {
    return (
        <main className="careers-page">
            <section
                className="careers-hero"
                aria-labelledby="careers-hero-title"
            >
                <div className="careers-hero-content careers-container">
                    <p className="careers-eyebrow">Careers at Northstar</p>

                    <h1 id="careers-hero-title">
                        Join our global team.
                    </h1>

                    <p className="careers-hero-copy">
                        We bring thoughtful people together to solve meaningful challenges. Find your place, do work you’re proud of and help shape what comes next.
                    </p>

                    <a
                        className="careers-button"
                        href="#open-roles"
                        onClick={(event) => {
                            event.preventDefault();

                            document
                                .getElementById("open-roles")
                                ?.scrollIntoView({
                                    behavior: "smooth",
                                    block: "start",
                                });
                        }}
                    >
                        Explore open roles

                        <svg
                            viewBox="0 0 20 20"
                            fill="none"
                            aria-hidden="true"
                        >
                            <path
                                d="M10 4v12m0 0 5-5m-5 5-5-5"
                                stroke="currentColor"
                                strokeWidth="1.7"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </a>
                </div>
            </section>

            <section
                className="careers-section careers-container"
                aria-labelledby="careers-benefits-title"
            >
                <div className="careers-section-heading">
                    <p className="careers-eyebrow">
                        The Northstar experience
                    </p>

                    <h2 id="careers-benefits-title">
                        A place to do your best work.
                    </h2>

                    <p>
                        We take care of our people so they can focus on doing
                        great things.
                    </p>
                </div>

                <div className="careers-benefits-grid">
                    <article className="careers-benefit-card">
                        <span
                            className="careers-benefit-icon"
                            aria-hidden="true"
                        >
                            <svg viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M12 3v18m4-14H9.8a3.3 3.3 0 0 0 0 6.6h4.4a3.3 3.3 0 0 1 0 6.6H7"
                                    stroke="currentColor"
                                    strokeWidth="1.7"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </span>

                        <h3>Competitive compensation</h3>

                        <p>
                            Fair pay and benefits that reflect your
                            contribution.
                        </p>
                    </article>

                    <article className="careers-benefit-card">
                        <span
                            className="careers-benefit-icon"
                            aria-hidden="true"
                        >
                            <svg viewBox="0 0 24 24" fill="none">
                                <circle
                                    cx="12"
                                    cy="12"
                                    r="8.5"
                                    stroke="currentColor"
                                    strokeWidth="1.7"
                                />

                                <path
                                    d="M12 7v5l3.5 2"
                                    stroke="currentColor"
                                    strokeWidth="1.7"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </span>

                        <h3>Flexible working</h3>

                        <p>
                            Work in a way that supports your life and your best
                            ideas.
                        </p>
                    </article>

                    <article className="careers-benefit-card">
                        <span
                            className="careers-benefit-icon"
                            aria-hidden="true"
                        >
                            <svg viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M4 10.5 12 4l8 6.5v9H4v-9Z"
                                    stroke="currentColor"
                                    strokeWidth="1.7"
                                    strokeLinejoin="round"
                                />

                                <path
                                    d="M9 19.5v-6h6v6"
                                    stroke="currentColor"
                                    strokeWidth="1.7"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </span>

                        <h3>Home office setup</h3>

                        <p>
                            Get the tools and support you need to work
                            comfortably.
                        </p>
                    </article>

                    <article className="careers-benefit-card">
                        <span
                            className="careers-benefit-icon"
                            aria-hidden="true"
                        >
                            <svg viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M4 19.5h16M6.5 16V9.5L12 6l5.5 3.5V16M9.5 16v-3h5v3M12 3v3"
                                    stroke="currentColor"
                                    strokeWidth="1.7"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </span>

                        <h3>Professional development</h3>

                        <p>
                            Keep learning with growth opportunities and
                            mentorship.
                        </p>
                    </article>
                </div>
            </section>

            <section
                className="careers-section careers-roles-section"
                id="open-roles"
                aria-labelledby="careers-roles-title"
            >
                <div className="careers-container">
                    <div className="careers-section-heading careers-roles-heading">
                        <div>
                            <p className="careers-eyebrow">
                                Open positions
                            </p>

                            <h2 id="careers-roles-title">
                                Find your next role.
                            </h2>
                        </div>

                        <p>
                            Select a role to view its complete description,
                            responsibilities, requirements and growth
                            opportunities.
                        </p>
                    </div>

                    <div className="careers-role-list">
                        {/* =====================================================
                            SALES REPRESENTATIVE
                        ====================================================== */}

                        <details className="careers-role-card">
                            <summary>
                                <span className="careers-role-main">
                                    <h3>Software Sales Representative</h3>

                                    <span className="careers-role-meta">
                                        <span>100% Remote</span>
                                        <span>2 Months Part-Time</span>
                                        <span>Potential Full-Time</span>
                                        <span>SaaS / Accounting Technology</span>
                                        <span>CA Firms & Accounting Professionals</span>
                                    </span>
                                </span>

                                <span className="careers-view-details">
                                    View details

                                    <svg
                                        viewBox="0 0 20 20"
                                        fill="none"
                                        aria-hidden="true"
                                    >
                                        <path
                                            d="m5 7.5 5 5 5-5"
                                            stroke="currentColor"
                                            strokeWidth="1.7"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </span>
                            </summary>

                            <div className="careers-role-description">

                                {/* INTRODUCTION */}
                                <div className="careers-jd-section">
                                    <h4>About the Role</h4>

                                    <p>
                                        We are looking for a motivated, curious and customer-focused Software Sales Representative to join our growing startup and help us bring our platform to Chartered Accountant (CA) firms and accounting professionals across India.
                                    </p>

                                    <p>
                                        This is a hands-on sales role where you will be responsible for the complete customer journey — from finding potential customers and starting the conversation to demonstrating the product, answering questions, handling objections, closing the deal and helping customers get successfully onboarded.
                                    </p>

                                    <p>
                                        Because we are an early-stage startup, we need someone who can move quickly, take ownership, work toward targets and continuously improve.
                                    </p>

                                    <p>
                                        Our platform is specifically designed to solve real problems faced by CA firms and accounting professionals. Therefore, this is not simply a traditional sales position where you are expected to memorize a list of features and convince customers to purchase.
                                    </p>

                                    <p>
                                        We are looking for someone who wants to understand how CA firms actually work, what problems they experience, what their clients expect, how their teams currently manage their work and where they lose time or efficiency.
                                    </p>
                                </div>

                                {/* WORK ARRANGEMENT */}
                                <div className="careers-jd-section">
                                    <h4>Work Arrangement - <span>100% Remote</span></h4>

                                    <p>
                                        This is a fully remote position. You will communicate with customers primarily through phone calls, video calls, online product demonstrations, email, messaging platforms and other digital communication channels used by the company.
                                    </p>

                                    <p>
                                        You should be comfortable working independently, managing your schedule, following up with customers and maintaining productivity without being physically present in an office.
                                    </p>
                                </div>

                                {/* LANGUAGE */}
                                <div className="careers-jd-section">
                                    <h4>Language Requirements</h4>

                                    <p>
                                        Most of our customers are expected to communicate in Hindi, so you should be comfortable having professional conversations in Hindi.
                                    </p>

                                    <p>
                                        However, not every customer will understand Hindi comfortably. You may also need to communicate with customers in English, particularly when dealing with customers who prefer English or when discussing certain technical or business-related topics.
                                    </p>

                                    <p>
                                        You should therefore be comfortable handling Hindi conversations, English conversations and Hindi-English mixed conversations.
                                    </p>

                                    <p>
                                        India has a diverse customer base with many regional languages. Hindi and English will be the primary workin languages for this role, but additi Indian language skills are a plus and are not mandatory.
                                    </p>
                                </div>

                                {/* RESPONSIBILITIES */}
                                <div className="careers-jd-section">
                                    <h4>Your Main Responsibilities</h4>

                                    <div className="careers-responsibility-item">
                                        <h5>1. Find New Customers</h5>

                                        <p>
                                            You will be responsible for identifying potential CA firms and accounting professionals who may benefit from our platform.
                                        </p>

                                        <ul>
                                            <li>Research potential CA firms and prospects.</li>
                                            <li>Find relevant potential customers.</li>
                                            <li>Initiate conversations.</li>
                                            <li>Make outbound calls.</li>
                                            <li>Contact potential customers through appropriate channels.</li>
                                            <li>Understand whether a prospect is a suitable customer.</li>
                                            <li>Maintain a pipeline of potential customers.</li>
                                            <li>Follow up consistently.</li>
                                            <li>Move qualified prospects through the sales process.</li>
                                        </ul>
                                    </div>

                                    <div className="careers-responsibility-item">
                                        <h5>2. Understand the Customer's Problems</h5>

                                        <p>
                                            Before selling the product, you should understand the customer's situation. You should ask meaningful questions about their current workflow, tools, problems, team challenges, client expectations and desired improvements.
                                        </p>

                                        <p>
                                            You should not simply listen for an opportunity to mention a product feature. You should listen to understand the actual problem behind the customer's question.
                                        </p>
                                    </div>

                                    <div className="careers-responsibility-item">
                                        <h5>3. Conduct Product Demonstrations</h5>

                                        <p>
                                            You will be responsible for demonstrating the platform to potential customers.
                                        </p>

                                        <ul>
                                            <li>Understand the customer's requirements before the demo.</li>
                                            <li>Explain the platform clearly.</li>
                                            <li>Demonstrate relevant features.</li>
                                            <li>Connect features to actual customer problems.</li>
                                            <li>Answer customer questions.</li>
                                            <li>Handle objections.</li>
                                            <li>Explain workflows.</li>
                                            <li>Adjust the demonstration based on customer needs.</li>
                                            <li>Identify questions that require internal confirmation.</li>
                                        </ul>
                                    </div>

                                    <div className="careers-responsibility-item">
                                        <h5>4. Answer Customer Questions Accurately</h5>

                                        <p>
                                            Customers may ask questions about features, workflows, accounting processes, client management, technical functionality, product limitations, integrations, implementation, pricing, future functionality, security and other business requirements.
                                        </p>

                                        <p>
                                            If you know the answer, provide the correct answer. If you do not know the answer, <strong>do not guess.</strong>
                                        </p>

                                        <p>
                                            Understand the customer's exact question, verify the answer with the appropriate internal team, get confirmation and then communicate the confirmed answer back to the customer.
                                        </p>
                                    </div>

                                    <div className="careers-responsibility-item">
                                        <h5>5. Close Deals Efficiently</h5>

                                        <p>
                                            As a startup, we need people who can
                                            move quickly. You will have sales
                                            targets and will be expected to work
                                            efficiently toward those targets.
                                        </p>

                                        <ul>
                                            <li>
                                                Follow up with prospects.
                                            </li>
                                            <li>
                                                Understand customer objections.
                                            </li>
                                            <li>
                                                Address genuine concerns.
                                            </li>
                                            <li>
                                                Communicate product value.
                                            </li>
                                            <li>
                                                Help customers make informed
                                                decisions.
                                            </li>
                                            <li>
                                                Negotiate within company-approved
                                                guidelines.
                                            </li>
                                            <li>
                                                Move qualified prospects toward
                                                closure.
                                            </li>
                                            <li>
                                                Complete required sales
                                                documentation.
                                            </li>
                                            <li>
                                                Coordinate the next steps after a
                                                successful sale.
                                            </li>
                                        </ul>

                                        <p>
                                            We want someone who is
                                            <strong>
                                                target-oriented and fast-moving
                                            </strong>
                                            , but moving quickly does not mean
                                            making unrealistic promises.
                                        </p>
                                    </div>

                                    <div className="careers-responsibility-item">
                                        <h5>6. Customer Onboarding</h5>

                                        <p>
                                            Your responsibility does not
                                            necessarily end when a customer agrees
                                            to purchase. You will also help ensure
                                            that customers successfully move into
                                            the onboarding process.
                                        </p>

                                        <ul>
                                            <li>
                                                Explain the next steps.
                                            </li>
                                            <li>
                                                Help customers understand how to
                                                get started.
                                            </li>
                                            <li>
                                                Coordinate with internal teams.
                                            </li>
                                            <li>
                                                Communicate customer requirements
                                                internally.
                                            </li>
                                            <li>
                                                Follow up with customers.
                                            </li>
                                            <li>
                                                Identify onboarding problems.
                                            </li>
                                            <li>
                                                Make sure customer expectations
                                                are properly communicated.
                                            </li>
                                            <li>
                                                Ensure commitments made during
                                                sales are correctly transferred to
                                                the onboarding team.
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="careers-responsibility-item">
                                        <h5>7. Handle Difficult Conversations Professionally</h5>

                                        <p>
                                            Sales conversations do not always go smoothly. Customers may become frustrated, question the product, challenge pricing, ask difficult questions, change requirements, become impatient, or behave aggressively.
                                        </p>

                                        <p>
                                            You are expected to remain calm, patient, professional, respectful and composed.
                                        </p>

                                        <p>
                                            You should never respond aggressively to an aggressive customer. If a customer becomes abusive or behaves inappropriately, maintain professionalism, avoid escalating the situation and report the incident to management through the appropriate process.
                                        </p>
                                    </div>
                                </div>

                                {/* CUSTOMER MINDSET */}
                                <div className="careers-jd-section">
                                    <h4>Think Like the Customer</h4>

                                    <p>This is one of the most important parts of this position.</p>

                                    <p>We do not want someone who only asks:</p>

                                    <blockquote>"What can I sell?"</blockquote>

                                    <p>We want someone who asks:</p>

                                    <blockquote>"What does this customer actually need?"</blockquote>

                                    <p>
                                        You should constantly think about what the customer is trying to accomplish, why they are asking a particular question, what they might be worried about, what would make them trust the platform and what might make them hesitate.
                                    </p>
                                </div>

                                {/* CA KNOWLEDGE */}
                                <div className="careers-jd-section">
                                    <h4>
                                        Develop Strong Knowledge of CA Firms
                                    </h4>

                                    <p>
                                        Our platform is specifically designed
                                        for CA firms and accounting
                                        professionals. Therefore, you will need
                                        to develop a strong understanding of
                                        the industry.
                                    </p>

                                    <p>You should learn about:</p>

                                    <ul>
                                        <li>
                                            How CA firms operate.
                                        </li>
                                        <li>
                                            How firms manage their clients.
                                        </li>
                                        <li>
                                            Common accounting workflows.
                                        </li>
                                        <li>
                                            Client communication.
                                        </li>
                                        <li>
                                            Task management.
                                        </li>
                                        <li>
                                            Team collaboration.
                                        </li>
                                        <li>
                                            Document management.
                                        </li>
                                        <li>
                                            Reporting and follow-ups.
                                        </li>
                                        <li>
                                            Operational inefficiencies.
                                        </li>
                                        <li>
                                            Manual processes.
                                        </li>
                                        <li>
                                            Common technology challenges.
                                        </li>
                                        <li>
                                            Problems faced by growing CA
                                            firms.
                                        </li>
                                        <li>
                                            Problems experienced by CA firms'
                                            clients.
                                        </li>
                                    </ul>

                                    <p>
                                        You do not need to know everything when you join. However, you must be willing to learn.
                                    </p>
                                </div>

                                {/* COMPUTER KNOWLEDGE */}
                                <div className="careers-jd-section">
                                    <h4>Basic Computer Knowledge</h4>

                                    <p>
                                        You should have a basic understanding of
                                        computers and be comfortable using
                                        modern software.
                                    </p>

                                    <p>You should be able to work with:</p>

                                    <ul>
                                        <li>Web applications.</li>
                                        <li>Browsers.</li>
                                        <li>Email.</li>
                                        <li>Video conferencing.</li>
                                        <li>Spreadsheets.</li>
                                        <li>Documents.</li>
                                        <li>Online communication tools.</li>
                                        <li>CRM or sales tools.</li>
                                        <li>
                                            Other software required for your
                                            daily work.
                                        </li>
                                    </ul>

                                    <p>
                                        You do not need to be a software
                                        developer. However, you should be
                                        comfortable learning and using
                                        technology.
                                    </p>
                                </div>

                                {/* UNKNOWN QUESTIONS */}
                                {/* <div className="careers-jd-section">
                                    <h4>
                                        What Happens When You Don't Know
                                        Something?
                                    </h4>

                                    <p>
                                        There will be situations where a
                                        customer asks you something you do not
                                        know. That is completely acceptable.
                                    </p>

                                    <p>
                                        What is <strong>not</strong> acceptable
                                        is providing an incorrect answer or
                                        making an unauthorized promise.
                                    </p>

                                    <p>
                                        For example, if a customer asks:
                                    </p>

                                    <blockquote>
                                        "Can your platform support this
                                        specific workflow?"
                                    </blockquote>

                                    <p>
                                        and you are not sure, you should not
                                        simply say "Yes" to keep the customer
                                        interested.
                                    </p>

                                    <p>
                                        Instead, communicate professionally:
                                    </p>

                                    <blockquote>
                                        "That's an important requirement. I
                                        don't want to give you an incorrect
                                        answer, so let me confirm this with our
                                        team and get back to you."
                                    </blockquote>

                                    <p>
                                        Then take ownership of finding the
                                        answer and following up with the
                                        customer.
                                    </p>

                                    <p>
                                        <strong>
                                            When in doubt, verify. Don't guess.
                                        </strong>
                                    </p>
                                </div> */}

                                {/* PERFORMANCE */}
                                <div className="careers-jd-section">
                                    <h4>Performance-Based Career Progression</h4>

                                    <p>
                                        We are a startup and we believe people
                                        who demonstrate strong performance
                                        should have the opportunity to grow
                                        quickly.
                                    </p>

                                    <h5>
                                        First 2 Months — Part-Time Evaluation Period
                                    </h5>

                                    <p>
                                        Your first <strong>2 months</strong>{" "} will be a part-time working period. During these two months, we will evaluate your sales activity, learning ability, product understanding, customer communication, lead generation, follow-up discipline, product demonstration skills, ability to handle objections, accuracy of communication, customer handling, target progress and overall improvement.
                                    </p>

                                    <p>
                                        This period allows both you and the
                                        company to determine whether the role
                                        is a good fit.
                                    </p>

                                    <h5>Transition to Full-Time</h5>

                                    <p>
                                        If you perform well during the first
                                        two months and demonstrate the expected
                                        level of progress, you will have the
                                        opportunity to transition to a&nbsp;
                                        <strong>permanent full-time position.</strong>
                                    </p>

                                    <p>
                                        Along with the transition to full-time
                                        employment, you will receive a&nbsp;
                                        <strong>competitive salary increase</strong>
                                        &nbsp;based on your performance and
                                        contribution during the initial period.
                                    </p>

                                    <p>
                                        We do not expect perfection during the
                                        first two months. What matters is that
                                        we can see consistent learning,
                                        improvement, ownership and measurable
                                        progress.
                                    </p>

                                    <h5>Six-Month Performance Milestone</h5>

                                    <p>
                                        Your first six months will be treated as an important performance period:
                                    </p>

                                    <div className="careers-performance-highlight">
                                        <strong>2 months part-time + 4 months full-time = 6 months total</strong>
                                    </div>

                                    <p>
                                        If you achieve the defined sales
                                        targets and maintain an overall&nbsp;
                                        <strong>85% or higher performance/success rate</strong>
                                        &nbsp;during the first six months, you will
                                        be eligible for:
                                    </p>

                                    <ul>
                                        <li>An additional performance bonus.</li>
                                        <li>An appraisal effective immediately from the 7th month.</li>
                                        <li>Continued opportunities for growth based on performance.</li>
                                    </ul>

                                    <h5>Annual Appraisal</h5>

                                    <p>
                                        After the initial six-month performance
                                        milestone, you will also participate in
                                        the company's regular annual appraisal
                                        process.
                                    </p>

                                    <p>
                                        Receiving an early performance-based
                                        appraisal does not remove your
                                        eligibility for the company's normal
                                        annual appraisal. You will have the
                                        opportunity to receive both
                                        performance-based recognition from
                                        Month 7 and the regular annual appraisal
                                        according to the company's appraisal
                                        cycle.
                                    </p>
                                </div>

                                {/* PERFORMANCE MEASUREMENT */}
                                <div className="careers-jd-section">
                                    <h4>What We Measure</h4>

                                    <p>
                                        Your performance may be evaluated based on multiple factors, including:
                                    </p>

                                    <ul>
                                        <li>Qualified leads generated.</li>
                                        <li>Customer conversations.</li>
                                        <li>Product demonstrations.</li>
                                        <li>Conversion rate.</li>
                                        <li>Sales target achievement.</li>
                                        <li>Deal closure time.</li>
                                        <li>Follow-up consistency.</li>
                                        <li>Customer onboarding.</li>
                                        <li>Customer satisfaction.</li>
                                        <li>Accuracy of information provided.</li>
                                        <li>Customer feedback.</li>
                                        <li>Product knowledge.</li>
                                        <li>Understanding of CA firm problems.</li>
                                        <li>Professionalism.</li>
                                        <li>Ability to handle difficult conversations.</li>
                                        <li>Learning and improvement.</li>
                                        <li>Overall contribution to the team.</li>
                                    </ul>

                                    <p>
                                        The <strong>85% performance milestone</strong>&nbsp;
                                        is not intended to measure only the
                                        number of deals you close. Quality,
                                        accuracy, customer handling and
                                        responsible selling are also important.
                                    </p>
                                </div>

                                {/* EDUCATION */}
                                {/* <div className="careers-jd-section">
                                    <h4>Educational Qualification</h4>

                                    <p>
                                        <strong>
                                            There is no specific degree
                                            requirement for this role.
                                        </strong>
                                    </p>

                                    <p>
                                        We are not primarily interested in what
                                        degree you have. You may come from
                                        Commerce, Management, Arts, Science,
                                        Computer Science, Engineering, Finance,
                                        Accounting, or any other educational
                                        background.
                                    </p>

                                    <p>
                                        Your degree does not determine whether
                                        you can succeed in this role.
                                    </p>

                                    <p>
                                        What matters more to us is your ability
                                        to learn, communicate, work, sell,
                                        understand customers, stay curious,
                                        maintain discipline, demonstrate
                                        progress and achieve targets.
                                    </p>

                                    <p>
                                        <strong>
                                            We value demonstrated work and
                                            progress more than a specific
                                            academic qualification.
                                        </strong>
                                    </p>
                                </div> */}

                                {/* IDEAL CANDIDATE */}
                                {/* <div className="careers-jd-section">
                                    <h4>Ideal Candidate</h4>

                                    <p>
                                        The ideal candidate is someone who:
                                    </p>

                                    <ul>
                                        <li>Enjoys talking to people.</li>
                                        <li>Is comfortable making calls.</li>
                                        <li>Can communicate professionally in Hindi.</li>
                                        <li>Can handle English conversations when required.</li>
                                        <li>Is curious about business problems.</li>
                                        <li>Wants to understand how CA firms operate.</li>
                                        <li>Is comfortable learning accounting-related concepts.</li>
                                        <li>Is comfortable using computers and software.</li>
                                        <li>Can learn a SaaS product thoroughly.</li>
                                        <li>Can conduct product demonstrations.</li>
                                        <li>Can handle objections.</li>
                                        <li>Can remain calm under pressure.</li>
                                        <li>Does not make promises without confirmation.</li>
                                        <li>Thinks from the customer's perspective.</li>
                                        <li>Is target-oriented.</li>
                                        <li>Moves quickly.</li>
                                        <li>Takes ownership.</li>
                                        <li>Accepts feedback.</li>
                                        <li>Continuously improves.</li>
                                        <li>Wants to grow with a startup.</li>
                                    </ul>
                                </div> */}

                                {/* WHAT THIS ROLE IS NOT */}
                                {/* <div className="careers-jd-section">
                                    <h4>What This Role Is NOT</h4>

                                    <p>This is <strong>not</strong> a role where the objective is to:</p>

                                    <blockquote>"Convince the customer to buy at any cost."</blockquote>

                                    <p>
                                        We do not want salespeople who make unrealistic promises, provide customers with incorrect information, hide product limitations, pressure customers unnecessarily, agree to functionality without confirmation, or become aggressive with customers.
                                    </p>

                                    <p>
                                        We want someone who can{" "}
                                        <strong>
                                            sell confidently while protecting the customer's trust and the company's reputation.
                                        </strong>
                                    </p>
                                </div> */}

                                {/* WHY JOIN */}
                                <div className="careers-jd-section">
                                    <h4>Why Join Us?</h4>

                                    <p>
                                        You will be joining at an exciting stage of our company's growth. Your work will directly contribute to growing the customer base, improving our sales process, understanding CA firms, improving the product, identifying customer pain points and improving customer onboarding.
                                    </p>

                                    <p>
                                        You won't simply be selling software. You will help us understand how CA firms work, what problems they face and how technology can make their work easier and more efficient.
                                    </p>

                                    <p>
                                        Your customer conversations can directly influence the future development of the product.
                                    </p>
                                </div>

                                {/* SUMMARY */}
                                <div className="careers-jd-section careers-jd-summary">
                                    <h4>In One Sentence</h4>

                                    <p>
                                        We are looking for a customer-focused, target-driven, curious and responsible salesperson who can find CA firms, understand their problems, demonstrate our platform, answer their questions accurately, close deals efficiently and help customers successfully adopt the product.
                                    </p>

                                    <p>If you are someone who believes:</p>

                                    <blockquote>
                                        "I don't just want to sell something — I want to understand the customer's problem and help them find the right solution."
                                    </blockquote>

                                    <p>then this could be a great opportunity for you.</p>
                                </div>

                                <div className="careers-apply-section">
                                    <div className="careers-apply-content">
                                        <h4>Ready to Join Us?</h4>

                                        <p>
                                            If this role sounds like a good fit for you and you are
                                            excited about helping CA firms solve real-world problems
                                            through technology, we would love to hear from you.
                                        </p>

                                        <a
                                            className="careers-apply-button"
                                            href="https://forms.gle/oNvowTjDoRav3uzZ7"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Apply for this role

                                            <svg
                                                viewBox="0 0 20 20"
                                                fill="none"
                                                aria-hidden="true"
                                            >
                                                <path
                                                    d="M5 10h10m0 0-4.5-4.5M15 10l-4.5 4.5"
                                                    stroke="currentColor"
                                                    strokeWidth="1.7"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </details>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Careers;
